module.exports = __webpack_public_path__ + "static/media/neuro-eob-example.7912cd40.png";